import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const setQueryStringWithoutPageReload = (qsValue: string) => {
  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + qsValue;
  window.history.pushState({ path: newurl }, '', newurl);
};

/**
 * Reads and writes a single query string param. Backed by react-router, so the value stays in
 * sync when a navigation only changes the query string on the page the user is already on.
 *
 * Setting an empty value removes the param.
 */
function useQueryString(key: string, initialValue: string): [string, (newValue: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) || initialValue;

  const onSetValue = useCallback(
    (newValue: string) => {
      setSearchParams((params) => {
        if (newValue) {
          params.set(key, newValue);
        } else {
          params.delete(key);
        }
        return params;
      });
    },
    [key, setSearchParams]
  );

  return [value, onSetValue];
}

export default useQueryString;
